<template>
   <div
    v-if="showComponent"
    class="form-group"
    @click="stopPropagation"
    :class="[
      lmButtonRootWrapperClass,
      {'avoid-pointer-events': this.isProcessing}
      ]"
    >
    <div
      id="lm-button-wrapper"
      :class="[
        lmButtonWrapperClass,
        alignClass
      ]"
      class="d-flex"
      @click="stopPropagation"
    >
      <button
        ref="lmButton"
        :type="type"
        :disabled="isDisabled"
        :style="{width: buttonWidth, height: buttonHeight, background: buttonBgColor, color: buttonColor}"
        class="btn"
        @click="onClick()"
        >
          <font-awesome-icon
            v-if="icon && !isProcessing"
            id="font-awesome-icon-edit"
            :icon="icon"
            :class="[iconPosition === 'left' ? 'mr-2' : 'ml-2']"
          />
          <LmSpinnerBorder @click="stopPropagation" class="lm-spinner-border" v-if="isProcessing"/>
          <span @click="stopPropagation" :class="{invisible: isProcessing}">{{text}}</span>
        </button>
    </div>
    <b-tooltip @click="stopPropagation" v-if="showTooltip" target="lm-button-wrapper" placement="top">
      {{tooltip.value}}
    </b-tooltip>
  </div>
</template>

<script>
import LmSpinnerBorder from '@/components/LmSpinnerBorder'

// Utils
import LmCommonProps from '@/mixins/LmCommonProps'

export default {
  mixins: [LmCommonProps],
  data () {
    return {
      buttonWidth: null,
      buttonHeight: null
    }
  },
  computed: {
    isDisabled () {
      return this.disabled || this.isProcessing
    },
    showTooltip () {
      if (this.tooltip) {
        if (this.tooltip.showOnlyOnDisabled && this.tooltip.value) {
          return this.disabled
        } else {
          return this.tooltip.value
        }
      }
    },
    text () {
      return this.name
    },
    alignClass () {
      if (this.buttonAlign === 'center') {
        return 'justify-content-center'
      } else if (this.buttonAlign === 'left') {
        return 'justify-content-left'
      } else if (this.buttonAlign === 'right') {
        return 'justify-content-end'
      }
    }
  },
  props: {
    type: {
      type: String,
      default: 'button'
    },
    name: {
      type: String
    },
    buttonBgColor: {
      type: String,
      default: '#4a86e8'
    },
    buttonColor: {
      type: String,
      default: '#fff'
    },
    buttonAlign: {
      type: String,
      default: 'center'
    },
    disabled: {
      type: Boolean
    },
    tooltip: {
      type: Object
    },
    isProcessing: {
      type: Boolean,
      default: false
    },
    lmButtonWrapperClass: {
      type: String
    },
    lmButtonRootWrapperClass: {
      type: String
    },
    icon: {
      type: String,
      default: ''
    },
    iconPosition: {
      type: String,
      default: 'left'
    },
    action: {
      type: String,
      default: 'submit'
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  components: {
    LmSpinnerBorder
  },
  methods: {
    async onClick (event) {
      try {
        this.$emit('click')
      } catch (error) {
        console.log(error)
      }
    },
    stopPropagation (event) {
      if (this.isDisabled) {
        event.stopPropagation()
      }
    }
  }
}
</script>
<style lang="sass" scoped>
  .btn
    white-space: nowrap
    box-shadow: $button-shadow
  .lm-spinner-border
    position: absolute
    top: 25%
    bottom: 0
    left: 0
    right: 0
    z-index: 9999
    margin: 0 auto
</style>
